<template>
  <div class="home-container">
    <div class="hx-breadcrumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>首页</el-breadcrumb-item>
        <el-breadcrumb-item>供应系统</el-breadcrumb-item>
        <el-breadcrumb-item>商品管理</el-breadcrumb-item>
        <el-breadcrumb-item
          :to="{
            name: 'servingManagement',
            query: { dateId: listParams.dateId },
          }"
          >上菜管理</el-breadcrumb-item
        >
        <el-breadcrumb-item>调整数据</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="hx-form-container box-shadow">
      <el-form :model="listParams" label-width="100px">
        <el-row :gutter="24">
          <el-col :span="8">
            <el-form-item label="基地名称：">
              <el-select size="small" v-model="listParams.farmId" style="width: 100%" placeholder="请选择基地名称">
                <el-option v-for="item in baseNameList" :label="item.title" :value="item.id" :key="item.id"> </el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="8">
            <el-form-item>
              <el-button size="small" type="primary" @click="loadColumnTitle"> 查询 </el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <hx-table-result :show-pager-on-one-page="false" :page-info="pager" :loading="tableLoading" @page-current-change="handleCurrentChange" @page-size-change="handleSizeChange">
      <div slot="action"></div>

      <hx-table-result-col>
        <div class="wrap-table-info-display" style="height: 32px">
          <div style="line-height: 30px; font-weight: 500" class="mgl20">
            <span>领货日期：</span>
            <span class="alert-text" v-if="deliveryTakenDate">{{ deliveryTakenDate | formatDate(true) }}</span>
          </div>
          <div style="position: absolute; right: 0">
            <el-button size="small" @click="resetTableData"> 重置 </el-button>

            <el-button :disabled="isDisabled" type="success" size="small" @click="saveEdit"> 保存修改 </el-button>
          </div>
        </div>
      </hx-table-result-col>

      <el-table slot="content" :data="tableData" max-height="800" border>
        <el-table-column prop="goodsId" align="center" fixed label="序号"> </el-table-column>

        <el-table-column prop="title" align="center" fixed label="产品名称"> </el-table-column>

        <el-table-column prop="spec" align="center" fixed label="规格"> </el-table-column>

        <el-table-column prop="stockTotal" align="center" label="基地供应能力"> </el-table-column>

        <el-table-column prop="little" align="center" label="富余量">
          <template slot-scope="scope">
            <el-input size="small" @change="reset($event, scope.$index)" v-model="scope.row.little"></el-input>
          </template>
        </el-table-column>
        <el-table-column align="center" v-for="(item, index) in columnList" :key="index" :label="item.logisticName">
          <template slot-scope="scope">
            <el-input size="small" v-if="showSuplly(columnList[index].plaLogisticSiteId, scope.row.stockProportionList, index, scope.$index)" v-model="scope.row.list[index]"></el-input>
            <span v-else>0</span>
          </template>
        </el-table-column>
      </el-table>
    </hx-table-result>
  </div>
</template>

<script>
export default {
  data() {
    return {
      listParams: {
        farmId: "",
        dateId: "",
      },
      baseNameList: [],
      tableLoading: false,
      tableData: [],
      logisticsSiteIdList: [],
      pager: {
        pageIndex: 1,
        pageSize: 15,
        total: 0,
      },
      supplyId: "",
      columnList: [],
      deliveryTakenDate: "",
      isDisabled: false,
    };
  },
  mounted() {
    if (this.$route.query.dateId) {
      this.listParams.dateId = this.$route.query.dateId;
    }
    this.loadBaseNameList();
  },
  computed: {
    showSuplly() {
      return function (id, list, index, tabIndex) {
        let show = list.findIndex(item => {
          return id == item.plaLogisticSiteId;
        });
        if (show < 0) {
          return false;
        } else {
          return true;
        }
      };
    },
  },
  methods: {
    /**
    设置供应点的富余量
    */
    reset(e, index) {
      let list = new Array(this.columnList.length).fill(0);
      let stockProportionList = this.tableData[index].stockProportionList;
      stockProportionList.map(item => {
        let plaLogisticSiteId = item.plaLogisticSiteId;
        let index1 = this.columnList.findIndex(item1 => {
          console.log(item1);
          return item1.plaLogisticSiteId == plaLogisticSiteId;
        });
        if (index1 >= 0) {
          list[index1] = ((item.stockProportion * e) / 100) >> 0;
        }
      });
      const array = JSON.parse(JSON.stringify(list));
      this.$set(this.tableData[index], "list", array);
    },
    /**
     * 初始化基地名称列表
     */
    loadBaseNameList() {
      this.$http({
        url: global.apiUrl + "/farm/title",
        method: "GET",
      })
        .then(res => {
          if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
            if (res.body.data) {
              this.baseNameList = res.body.data.dataList;
              this.listParams.farmId = this.baseNameList[0].id;
              this.loadColumnTitle();
            } else {
            }
          }
        })
        .catch(err => {
          console.error(err);
        });
    },
    /**
     * 初始化表头
     */
    loadColumnTitle() {
      this.$http({
        url: global.apiUrl + "/farm/farm-stock-name",
        method: "GET",
        params: {
          dateId: this.listParams.dateId,
          farmId: this.listParams.farmId,
        },
      })
        .then(res => {
          if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
            this.columnList = res.body.data.columnList;
            this.logisticsSiteIdList = [];
            this.columnList.map(item => {
              this.logisticsSiteIdList.push(item.plaLogisticSiteId);
            });
            this.loadTableData();
          } else {
          }
        })
        .catch(err => {
          console.error(err);
        });
    },
    /**
     * 初始化列表数据
     */
    loadTableData() {
      this.tableLoading = true;
      this.$http({
        url: global.apiUrl + "/farm/farm-stock-change",
        method: "GET",
        params: this.listParams,
      })
        .then(res => {
          if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
            this.tableLoading = false;
            if (res.body.data) {
              this.tableData = res.body.data.dataList;
              this.deliveryTakenDate = res.body.data.supplyDate;
            } else {
              this.tableData = [];
            }
          } else {
            this.tableLoading = false;
          }
        })
        .catch(err => {
          this.tableLoading = false;

          console.error(err);
        });
    },
    /**
     * pageIndex的change事件
     * @param val
     */
    handleCurrentChange(val) {
      this.pager.pageIndex = val;
      this.loadTableData();
    },
    /**
     * pageSize的change事件
     * @param val
     */
    handleSizeChange(val) {
      this.pager.pageSize = val;
      this.loadTableData();
    },
    /**
     * 重置table数据
     */
    resetTableData() {
      this.tableLoading = true;
      this.tableData.map(item1 => {
        item1.little = "";
        item1.stock = "";
        item1.list.map((item2, i) => {
          item1.list[i] = "";
        });
      });
      this.tableLoading = false;
    },
    saveEdit() {
      this.isDisabled = true;
      const bodyParams = {
        farmId: this.listParams.farmId,
        supplyId: this.supplyId,
        goodsId: 1,
        dateId: this.listParams.dateId,
        logisticsSiteIdList: this.logisticsSiteIdList,
        tableList: this.tableData,
      };
      this.$http({
        url: global.apiUrl + "/farm/save-info",
        method: "POST",
        body: bodyParams,
      })
        .then(res => {
          if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
            this.isDisabled = false;
            this.$message.success(res.body.info);
            this.loadTableData();
          } else {
            this.isDisabled = false;
          }
        })
        .catch(err => {
          this.isDisabled = false;

          console.error(err);
        });
    },
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.supplyId = parseInt(vm.$route.params.supplyId);
    });
  },
};
</script>

<style lang="less" scoped>
.home-container {
  .alert-text {
    color: #e9a021;
    cursor: default;
  }
}
</style>
